import { createSlice } from '@reduxjs/toolkit'

const CHAT_CUSTOMIZATION_KEY = 'chatCustomization'

const getStoredCustomization = () => {
  try {
    const stored = localStorage.getItem(CHAT_CUSTOMIZATION_KEY)
    return stored ? JSON.parse(stored) : null
  } catch {
    return null
  }
}

const saveCustomization = customization => {
  try {
    localStorage.setItem(CHAT_CUSTOMIZATION_KEY, JSON.stringify(customization))
  } catch (error) {
    console.error('Failed to save customization:', error)
  }
}

export const defaultCustomization = {
  backgroundColor: '#F0F2F5',
  senderBubbleColor: '#0084FF',
  senderTextColor: '#FFFFFF',
  receiverBubbleColor: '#FFFFFF',
  receiverTextColor: '#000000',
  tickColor: '#0084FF',
  textSize: 15,
  messageGap: 6,
}

const initialState = {
  ui: {
    searchQuery: '',
    chatCustomization: getStoredCustomization() || defaultCustomization,
    isCustomizationOpen: false,
  },
}

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setSearchQuery: (state, action) => {
      state.ui.searchQuery = action.payload
    },
    updateChatCustomization: (state, action) => {
      state.ui.chatCustomization = {
        ...state.ui.chatCustomization,
        ...action.payload,
      }
      saveCustomization(state.ui.chatCustomization)
    },
    resetCustomization: state => {
      state.ui.chatCustomization = defaultCustomization
      saveCustomization(defaultCustomization)
    },
    toggleCustomizationPanel: state => {
      state.ui.isCustomizationOpen = !state.ui.isCustomizationOpen
    },
    resetChat: () => initialState,
  },
})

export const {
  setSearchQuery,
  updateChatCustomization,
  resetCustomization,
  toggleCustomizationPanel,
  resetChat,
} = chatSlice.actions

export default chatSlice.reducer